export class ClassUtils {
    public static readonly TAG: string = "[ClassUtils]";

    /**
    * [addClass description]
    * @param  {HTMLElement} pDomElement [description]
    * @param  {string}      pClassName  [description]
    */
    static addClass(pDomElement: HTMLElement, pClassName: string): void {
        if (!pDomElement) {
            console.warn(ClassUtils.TAG, "addClass()", "HTMLElement passed as parameter is undefined!");
            return;
        }

        // Checks if class not already present.
        if (ClassUtils.hasClass(pDomElement, pClassName)) { return; }

        pDomElement.className += " " + pClassName;
    }

    /**
    * [removeClass description]
    * @param  {HTMLElement} pDomElement [description]
    * @param  {string}      pClassName  [description]
    */
    static removeClass(pDomElement: HTMLElement, pClassName: string): void {
        if (!pDomElement) {
            console.warn(ClassUtils.TAG, "removeClass()", "HTMLElement passed as parameter is undefined!");
            return;
        }

        pDomElement.className = pDomElement.className.replace(new RegExp("(?:^|\\s)" + pClassName + "(?!\\S)", "g"), "");
    }

    /**
    * [containsClass description]
    * @param  {HTMLElement} pDomElement [description]
    * @param  {string}      pClassName  [description]
    * @return {boolean}                 [description]
    */
    static hasClass(pDomElement: HTMLElement, pClassName: string): boolean {
        if (!pDomElement) {
            console.warn(ClassUtils.TAG, "hasClass()", "HTMLElement passed as parameter is undefined!");
            return;
        }

        return pDomElement.className.match(new RegExp("(?:^|\\s)" + pClassName + "(?!\\S)", "g")) ? true : false;
    }
}



// WEBPACK FOOTER //
// ./src/app/util/ClassUtils.ts